"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(require("lodash"));
var jsts = __importStar(require("jsts"));
var Geometry_1 = __importDefault(require("./Geometry"));
var GeometryType_1 = require("./GeometryType");
var Polygon_1 = __importDefault(require("./Polygon"));
var Validators_1 = __importDefault(require("../shared/Validators"));
var LinearRing = /** @class */ (function (_super) {
    __extends(LinearRing, _super);
    function LinearRing(coordinates) {
        var _this = _super.call(this) || this;
        _this._coordinates = new Array();
        if (!lodash_1.default.isUndefined(coordinates)) {
            coordinates.forEach(function (c) { return _this._coordinates.push(c); });
        }
        if (!_this.closed()) {
            var first = lodash_1.default.chain(coordinates).first().clone().value();
            _this._coordinates.push(first);
        }
        return _this;
    }
    Object.defineProperty(LinearRing.prototype, "type", {
        get: function () {
            return GeometryType_1.GeometryType.Polygon;
        },
        enumerable: true,
        configurable: true
    });
    LinearRing.prototype.coordinatesFlat = function () {
        return this._coordinates;
    };
    LinearRing.prototype.coordinates = function () {
        return this._coordinates.map(function (c) { return [c.x, c.y]; });
    };
    LinearRing.prototype.toJSON = function () {
        return new Polygon_1.default(this).toJSON();
    };
    LinearRing.prototype.closed = function () {
        var first = lodash_1.default.first(this._coordinates);
        var last = lodash_1.default.last(this._coordinates);
        return lodash_1.default.isEqual(first, last);
    };
    LinearRing.prototype._ts = function () {
        return Geometry_1.default._factory.createLinearRing(this._coordinates.map(function (c) { return new jsts.geom.Coordinate(c.x, c.y); }));
    };
    LinearRing.prototype._clone = function (convert) {
        var tmpCoordinate = this._coordinates.map(function (c) {
            var tmp = lodash_1.default.clone(c);
            if (convert !== undefined) {
                tmp = convert(tmp);
            }
            return tmp;
        });
        return new LinearRing(tmpCoordinate);
    };
    LinearRing.fromNumbers = function () {
        var coordinates = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            coordinates[_i] = arguments[_i];
        }
        Validators_1.default.validateCoordinateNumbers(coordinates, 6);
        var ring = new LinearRing(lodash_1.default.chunk(coordinates, 2).map(function (c) { return ({ x: c[0], y: c[1] }); }));
        return ring;
    };
    LinearRing._from = function (ring) {
        return new LinearRing(ring.getCoordinates().map(function (c) { return ({ x: c.x, y: c.y }); }));
    };
    LinearRing.prototype.counterClockwise = function () {
        var topPoint = { x: Number.NEGATIVE_INFINITY, y: Number.NEGATIVE_INFINITY };
        var topPointIndex = 0;
        var pointCount = this._coordinates.length;
        for (var i = 0; i < pointCount; i++) {
            if (this._coordinates[i].y > topPoint.y) {
                topPoint = this._coordinates[i];
                topPointIndex = i;
            }
        }
        var previousPointIndex = topPointIndex - 1;
        if (previousPointIndex < 0) {
            previousPointIndex = pointCount - 2;
        }
        var previousPoint = this._coordinates[previousPointIndex];
        var nextPointIndex = topPointIndex + 1;
        if (nextPointIndex >= pointCount) {
            nextPointIndex = 1;
        }
        var nextPoint = this._coordinates[nextPointIndex];
        var previousDistanceX = previousPoint.x - topPoint.x;
        var previousDistanceY = previousPoint.y - topPoint.y;
        var nextDistanceX = nextPoint.x - topPoint.x;
        var nextDistanceY = nextPoint.y - topPoint.y;
        var distance = nextDistanceX * previousDistanceY - nextDistanceY * previousDistanceX;
        if (distance === 0) {
            return previousPoint.x > nextPoint.x;
        }
        else {
            return distance > 0;
        }
    };
    LinearRing.prototype.forEachCoordinates = function (callback) {
        this._coordinates.forEach(callback);
    };
    return LinearRing;
}(Geometry_1.default));
exports.default = LinearRing;
